export default "__VITE_ASSET__ab9a2dc6__"